const is_valid_timestamp = function(timestamp) {
    const right_length = timestamp.toString().length === 13;
    const new_date = new Date(timestamp);
    const is_valid = new_date.getFullYear() > 2000;
    return right_length && is_valid;
}

const transform_to_date_if_timestamp = function(value) {
    // convert UNIX timestamp to casual date
    if (!is_valid_timestamp(value)) {
        return value;
    }
    return new Date(value).toISOString().slice(0, 10);
};

const round = function(value, n) {
    // округление до `n` знаков после запятой
    const m = Math.pow(10, n);
    return Math.round(value * m) / m;

};

const is_empty = function(obj) {
    return !obj || Object.keys(obj).length === 0;
};

const init_gradient_table = function() {
    const GRADIENT_COLORS = [
        '#ECF8FF',
        '#E6F5FF',
        '#DBF0FF',
        '#D1ECFF',
        '#C7E8FF',
        '#BDE4FF',
        '#B3E0FF',
        '#A8DCFF',
        '#9ED8FF',
        '#94D4FF',
        '#8AD0FF',
        '#80CCFF',
        '#78C4FF',
    ];
    const calculate_ranges = function(rows) {
        if (is_empty(rows)) {
            return {};
        }
        var ranges = {};
        var column_keys = Object.keys(rows[1] || rows[0]);
        for (var key of column_keys) {
            var column_values = rows.map(row => row[key]).filter(v => v >= 0);
            ranges[key] = {
                min: Math.min.apply(Math, column_values),
                max: Math.max.apply(Math, column_values),
            };
        }
        return ranges;
    };
    let vm = {ranges: {}};
    return {
        get_bg_color: function(value, key) {
            if (value == -1 || !vm.ranges.hasOwnProperty(key)) {
                return '';
            }
            var { min, max } = vm.ranges[key];
            var value_coef = (value - min) / (max - min);  // значение от 0 до 1
            var color_index = Math.floor(value_coef * (GRADIENT_COLORS.length - 1));
            return GRADIENT_COLORS[color_index];
        },
        set_rows: function(rows) {
            vm.ranges = calculate_ranges(rows);
        },
    };
};

const download_csv_file = function(name, csv_data) {
    const blob = new Blob([csv_data], {type: 'text/csv'});
    const a = window.document.createElement('a');
    a.href = window.URL.createObjectURL(blob);
    a.download = name.replace('.', '') + '_' + new Date().toISOString().slice(0, 10) + '.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
};

const natural_sort = function(xs) {
    var collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
    xs.sort(collator.compare);
    return xs;
};


const provider_states_by_gameplay = function($stateProvider, states_map) {
    const allowed_states = states_map[GAMEPLAY];
    if (!allowed_states) {
        return $stateProvider;
    }
    return {
        state: function(name, cfg) {
            if (!cfg.abstract && !allowed_states.includes(name)) {
                return $stateProvider;
            }
            if (cfg.abstract) {
                cfg.menu.childs = cfg.menu.childs.filter(x => allowed_states.includes(x.state));
            }
            return $stateProvider.state(name, cfg);
        },
    };
};

export {
    init_gradient_table,
    is_empty,
    round,
    transform_to_date_if_timestamp,
    download_csv_file,
    natural_sort,
    provider_states_by_gameplay,
};
